const theme = {
  placeholder: "editor-placeholder",
  paragraph: "editor-paragraph",
  heading: {
    h1: "text-headline-small font-semibold",
    h2: "text-title-large font-semibold",
    h3: "text-title-medium font-semibold",
    h4: "text-title-small font-semibold",
    h5: "text-label-large font-semibold",
    h6: "text-label-medium font-semibold"
  },
  quote: "editor-quote",
  list: {
    ol: "list-decimal pl-6",
    ul: "list-disc pl-6",
    checklist: "editor-checklist",
    listitem: "editor-listitem",
    listitemChecked: "editor-listitem-checked",
    listitemUnchecked: "editor-listitem-unchecked"
  },
  text: {
    bold: "font-bold",
    italic: "italic",
    underline: "underline"
  },
  link: "text-sys-brand-primary cursor-pointer"
};

export default theme;
